export default __webpack_public_path__ + "static/media/weely_logo.1ab105ec.png";